module.exports = __webpack_public_path__ + "img/4.26ccd4c1.png";